import { Typography } from '@innovamat/glimmer-components';
import { Trans } from 'react-i18next';

type TranslatorComponentProps = {
  translationKey: string;
  onPersonalizeLinkClick?: () => void;
  onReportLinkClick?: () => void;
};

export const TranslatorComponent = ({
  translationKey,
  onPersonalizeLinkClick,
  onReportLinkClick,
}: TranslatorComponentProps): JSX.Element => {
  return (
    <Trans
      i18nKey={translationKey}
      defaults={translationKey}
      shouldUnescape={true}
      components={{
        b: <b />,
        br: <br />,
        li: <li />,
        ul: <ul />,
        personalizeLink: (
          <Typography.Link2
            onClick={onPersonalizeLinkClick || ((e) => e.preventDefault())}
          />
        ),
        reportLink: (
          <Typography.Link2
            onClick={onReportLinkClick || ((e) => e.preventDefault())}
          />
        ),
      }}
    />
  );
};
